import { render, staticRenderFns } from "./formEquipment.vue?vue&type=template&id=8476da6e"
import script from "./formEquipment.vue?vue&type=script&lang=js"
export * from "./formEquipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8476da6e')) {
      api.createRecord('8476da6e', component.options)
    } else {
      api.reload('8476da6e', component.options)
    }
    module.hot.accept("./formEquipment.vue?vue&type=template&id=8476da6e", function () {
      api.rerender('8476da6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/transferRoute/components/formEquipamento/formEquipment.vue"
export default component.exports